import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-arrow--up\"><path d=\"m10 3.418-6.582 6.583.663.662 5.45-5.45v11.368h.938V5.213l5.45 5.45.662-.662-6.58-6.583Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol